import Dropdown from 'style-guide/DropdownV2';
import Button from 'style-guide/Button';
import Menu, { MenuItem } from 'style-guide/Menu';
import MODAL_TYPES from 'constants/modals';
import { showModal } from 'store/slices/modal';
import Text from 'style-guide/Typography/Text';

import { generateEntityPagePath } from 'Components/App/Helpers/entityPagesRoute/pathGenerateHelper';
import { formStepsId } from 'Components/EntityFormSections/Stepper/helper';
import { ENTITY_TYPES } from 'common';

const { ORGANIZATION } = ENTITY_TYPES;

const orgSettingsPath = (lib) => generateEntityPagePath(ORGANIZATION.key, lib.id, lib.urlName, formStepsId.naming);

const setModalTitleText = (modalTitle, item) => {
  switch (modalTitle) {
    case 'delete':
      return (
        <Text $variant={2} $dark={100}>
          You want to delete the organization?
        </Text>
      );
    case 'archive':
      return (
        <Text $variant={2} $dark={100}>
          {`You want to ${item.isArchive === true ? 'unarchive' : 'archive'} the organization?`}
        </Text>
      );
    default:
      return null;
  }
};

const showConfirmationModal = (dispatch, deleteDepartment, updateArchive, item, title) => {
  dispatch(
    showModal({
      type: MODAL_TYPES.CONFIRMATION,
      params: {
        body: {
          title: setModalTitleText(title, item),
          onOk: () => {
            switch (title) {
              case 'delete':
                deleteDepartment({ id: item.id });
                break;
              case 'archive':
                updateArchive({
                  courseId: item.id,
                  isArchive: !item.isArchive,
                  mode: 'organization',
                });
                break;
              default:
                null;
            }
          },
        },
      },
    })
  );
};
const Actions = ({ item, setCourseUserData, dispatch, deleteOrganization, updateArchive }) => (
  <div className='d-flex align-items-center'>
    <Dropdown
      trigger='click'
      placement='bottomLeft'
      className='role-dropdown'
      overlay={
        <Menu>
          <MenuItem key='edit' onClick={() => setCourseUserData(item, orgSettingsPath)}>
            Edit Organization
          </MenuItem>
          <MenuItem
            key='archive'
            onClick={() => showConfirmationModal(dispatch, deleteOrganization, updateArchive, item, 'archive')}
          >
            {item.isArchive === true ? 'Unarchive Organization' : 'Archive Organization'}
          </MenuItem>
          <MenuItem
            key='remove'
            onClick={() => showConfirmationModal(dispatch, deleteOrganization, updateArchive, item, 'delete')}
          >
            Remove Organization
          </MenuItem>
        </Menu>
      }
    >
      <Button variant='link'>...</Button>
    </Dropdown>
  </div>
);

export default Actions;
